export default function getCanPlayAds() {
  return !!window.google;
}
